import styled from "styled-components";
const TensorGridImpl = styled("div")(
  {
    display: "grid",
    transform: "translateZ(0)"
  },
  ({ $numberOfColumns }) => ({
    gridTemplateColumns: `repeat(${$numberOfColumns}, auto)`
  })
);
const TensorGridHeader = styled("div").attrs({
  role: "columnheader"
})(
  ({ theme }) => ({
    backgroundColor: "#fafafa",
    borderColor: theme.borderColor,
    borderStyle: "solid",
    borderWidth: `0 1px 1px 0`,
    boxSizing: "border-box",
    color: theme.color.black9,
    fontWeight: theme.fontWeight.medium,
    minWidth: 0,
    padding: "5px 12px",
    position: "sticky",
    top: 0,
    zIndex: 1
  }),
  ({ $firstColumn }) => $firstColumn ? {
    paddingLeft: 16
  } : void 0,
  ({ $lastColumn }) => $lastColumn ? {
    borderRightWidth: 0
  } : void 0
);
export {
  TensorGridHeader,
  TensorGridImpl
};
